import React, { Fragment} from 'react'
import { Dialog, Transition } from '@headlessui/react';
import { useForm } from 'react-hook-form';
import { closeBtn, formBtn1 } from '../Utils/CustomClasses';

export default function ViewAdminDetailsModal({AdminModal,setAdminModal,data}) {
const { register, handleSubmit, control, watch, reset, formState: { errors }, setValue } = useForm();    
    const toggle = () => {
        setAdminModal(false);
        reset();
    } 
    return (
        <>
            <Transition appear show={AdminModal} as={Fragment}>
                <Dialog as="div" className="relative z-[100]" onClose={toggle}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>
                    <div className="fixed inset-0 overflow-y-scroll">
                        <div className="flex items-center justify-center min-h-full p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-2xl overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                                    <Dialog.Title
                                        as="h2"
                                        className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                                    >
                                        Admin Details
                                    </Dialog.Title>
                                    <div className="p-4">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <p className='font-sans-serif font-bold text-[20px] text-black'>First Name</p>
                                                <p>{data?.first_name || 'NA'}</p>
                                            </div>
                                            <div>
                                                <p className='font-sans-serif font-bold text-[20px] text-black'>Last Name</p>
                                                <p>{data?.last_name}</p>
                                            </div>
                                            <div>
                                                <p className='font-sans-serif font-bold text-[20px] text-black'>Email</p>
                                                <p>{data?.email}</p>
                                            </div>
                                            <div>
                                                <p className='font-sans-serif font-bold text-[20px] text-black'>Contact No.</p>
                                                <p>{data?.phone_number}</p>
                                            </div>
                                            <div>
                                                <p className='font-sans-serif font-bold text-[20px] text-black'>Role Name</p>
                                                <p>{data?.role?.roleName}</p>
                                            </div>
                                            <div>
                                                <p className='font-sans-serif font-bold text-[20px] text-black'>Company Name</p>
                                                <p>{data?.company?.companyName}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                                        <button
                                            type="button"
                                            className={closeBtn}
                                            onClick={toggle}
                                        >
                                            Close
                                        </button>
                                    </footer>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}
